import { useEffect, useMemo, useRef, useState } from 'react'
import { AcCard, AcDataGrid, AcSwitch, AcTypography, AcSelect } from '@components'
import { DataGridStore } from 'src/stores/datagrid.stores'
import { useStore } from '@hooks/use-store'
import { ROUTE_PATHS, STORE_KEYS } from '@constants'

const REFRESH_OPTIONS = [
  { id: '15000', label: '15s' },
  { id: '30000', label: '30s' },
  { id: '60000', label: '1m' },
  { id: '300000', label: '5m' },
]

export const SystemJobBatchesTab = () => {
  const store = useStore()
  const dataGridStore = useMemo(() => new DataGridStore(store, STORE_KEYS.SYSTEM_JOB_BATCHES), [store])
  const [autoRefresh, setAutoRefresh] = useState(false)
  const [intervalMs, setIntervalMs] = useState<number>(30000)
  const intervalRef = useRef<number | null>(null)

  useEffect(() => {
    if (autoRefresh) {
      // call immediately on enable
      dataGridStore.getData()
      intervalRef.current = window.setInterval(() => {
        dataGridStore.getData()
      }, intervalMs)
    }
    return () => {
      if (intervalRef.current) window.clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }, [autoRefresh, intervalMs])

  return (
    <div style={{ marginTop: 24, marginBottom: 12 }}>
      <AcCard>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <AcTypography element="span" size="sm">Auto-refresh</AcTypography>
          <AcSwitch
            checked={autoRefresh}
            onClick={() => setAutoRefresh(v => !v)}
          />
          <AcSelect
            name="refresh-interval"
            id="system-job-batches-refresh-interval"
            options={REFRESH_OPTIONS}
            valueKey="id"
            labelKey="label"
            defaultValue={REFRESH_OPTIONS.find(o => o.id === String(intervalMs))}
            onChange={(opt: any) => setIntervalMs(parseInt(opt?.id ?? opt))}
            placeholder="Interval"
            noMinWidth
          />
        </div>
      </AcCard>
      <AcDataGrid store={dataGridStore} detailPath={ROUTE_PATHS.APP_JOB_BATCH_DETAIL} />
    </div>
  )
}
